const Label = ({ children, optional, className = '' }) => {
  return (
    <label className={`text-sm font-bold text-gray-700 ${className}`}>
      <div className="font-bold inline">{children}</div>{' '}
      {optional && <span className="font-normal text-gray-500">(optional)</span>}
    </label>
  );
};

export default Label;
